<script lang="ts">
  import { navigate } from "svelte-navigator";
  export let secret_key: string = "";

  let pending = false;

  let customer = "";
  let error = "";
  async function createPaymentIntent(customer: string) {
    error = null;
    const intentResult = await fetch(
      "https://api.stripe.com/v1/setup_intents",
      {
        method: "post",
        body: `payment_method_types%5B%5D=card&usage=off_session&customer=${customer}`,
        headers: {
          Authorization: `Bearer ${secret_key}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    ).then((response) => response.json());

    if (intentResult.error) {
      error = intentResult.error.message;
      return null;
    }

    return intentResult.client_secret;
  }

  async function submit() {
    if (pending) return;
    pending = true;
    const payment_intent = await createPaymentIntent(customer);
    pending = false;
    if (payment_intent) {
      navigate("/add_method/" + payment_intent);
    }
  }

  function paste() {
    navigator.clipboard.readText().then((clipText) => (customer = clipText));
  }
</script>

<div class="wrapper">
  <h2>Step 1 - Paste Customer ID</h2>
  <div>
    <input type="text" bind:value={customer} />
    <button on:click={paste} disabled={pending}> Paste </button>
  </div>
  <div style="margin-top:2em;">
    <button on:click={submit} disabled={pending || customer.length == 0}>
      Continue
    </button>
  </div>
  {#if error}
    <div class="error">Error: {error}</div>
  {/if}
</div>

<style>
  .wrapper {
    margin: 20px;
    padding: 10px;
    background-color: var(--color-bg);
  }

  .error {
    padding: 2em;
    color: #ffe100;
    font-size: 1.2em;
  }
</style>
